webpackJsonp([152176518627018],{

/***/ 319:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(23);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Created by vaibhav on 2/4/18
	 */
	var PostCard = function PostCard(_ref) {
	    var posts = _ref.posts;
	
	    return _react2.default.createElement(
	        'div',
	        { className: 'container' },
	        posts.filter(function (post) {
	            return post.node.frontmatter.templateKey === 'article-page';
	        }).map(function (_ref2) {
	            var post = _ref2.node;
	            return _react2.default.createElement(
	                'div',
	                {
	                    className: 'content postcard',
	                    style: { border: '1px solid #eaecee', padding: '2em 4em' },
	                    key: post.id
	                },
	                _react2.default.createElement(
	                    'p',
	                    null,
	                    _react2.default.createElement(
	                        _gatsbyLink2.default,
	                        { className: 'has-text-primary', to: post.fields.slug },
	                        post.frontmatter.title
	                    ),
	                    _react2.default.createElement(
	                        'span',
	                        null,
	                        ' \u2022 '
	                    ),
	                    _react2.default.createElement(
	                        'small',
	                        null,
	                        post.frontmatter.date
	                    )
	                ),
	                _react2.default.createElement(
	                    'p',
	                    null,
	                    post.excerpt,
	                    _react2.default.createElement('br', null),
	                    _react2.default.createElement('br', null),
	                    _react2.default.createElement(
	                        _gatsbyLink2.default,
	                        { className: 'button is-small', to: post.fields.slug },
	                        'Keep Reading \u2192'
	                    )
	                )
	            );
	        })
	    );
	};
	
	exports.default = PostCard;
	module.exports = exports['default'];

/***/ }),

/***/ 322:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.blogPageQuery = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(1);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _NavBar = __webpack_require__(14);
	
	var _NavBar2 = _interopRequireDefault(_NavBar);
	
	var _reactHelmet = __webpack_require__(13);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _PostCard = __webpack_require__(319);
	
	var _PostCard2 = _interopRequireDefault(_PostCard);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Created by vaibhav on 31/3/18
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	
	var BlogPage = function (_Component) {
	    _inherits(BlogPage, _Component);
	
	    function BlogPage() {
	        _classCallCheck(this, BlogPage);
	
	        return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	    }
	
	    BlogPage.prototype.render = function render() {
	        var data = this.props.data;
	        var posts = data.allMarkdownRemark.edges;
	
	
	        return _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	                _reactHelmet2.default,
	                null,
	                _react2.default.createElement(
	                    'title',
	                    null,
	                    'Blog | Common Energy'
	                )
	            ),
	            _react2.default.createElement(_NavBar2.default, null),
	            _react2.default.createElement(
	                'section',
	                { className: 'hero is-primary is-bold' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'hero-body' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'container' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'columns' },
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'column is-10 is-offset-1' },
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'section' },
	                                    _react2.default.createElement(
	                                        'h1',
	                                        { className: 'title' },
	                                        'Blog'
	                                    )
	                                )
	                            )
	                        )
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'section',
	                { className: 'section' },
	                _react2.default.createElement(_PostCard2.default, { posts: posts })
	            )
	        );
	    };
	
	    return BlogPage;
	}(_react.Component);
	
	exports.default = BlogPage;
	
	
	BlogPage.propTypes = {
	    data: _propTypes2.default.shape({
	        allMarkdownRemark: _propTypes2.default.shape({
	            edges: _propTypes2.default.array
	        })
	    })
	};
	
	var blogPageQuery = exports.blogPageQuery = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-blog-index-js-b1ff1609bbb4a7035652.js